export const allowedYears = [...Array(51).keys()].map(i => i + 2000);

export const MAX_YEAR = 2050;

export const MIN_YEAR = 2000;